import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { fetchSchoolMissions, teacherUpdateSchoolMission } from '../../services2/schoolMissions.service';
import { useSetting } from '../../util/useSetting';
import VerticalDragableList from './components/VerticalDragableList';
import SliderPage from './components/SliderPage';
import ClassSelectionPopup from './components/ClassSelectionPopup';
import AbilityPointsLeft from './components/AbilityPointsLeft';
import AbilityPointsRight from './components/AbilityPointsRight';
import SettingPopup from './components/SettingPopup';


function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const { fontSize } = useSetting();

    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {
            _id: id
        }
        let result = await fetchSchoolMissions(props.token.token, filter, { limit: 1, skip: 0 });
        if (result.result) {
            let d = result.result?.[0] || null;
            if (!d.pages) d.pages = d.mission?.pages || [];
            if (!d.pages2) d.pages2 = JSON.parse(JSON.stringify(d.mission?.pages || []))
            if (!d.questions) d.questions = JSON.parse(JSON.stringify([...d.mission?.pages[0]?.questions || [], ...d.mission?.pages[1]?.questions || []]));
            setdata(d)
        } else {
            alert('Fetch data error')
        }
        setisLoading(false)
    }



    useEffect(() => {
        fetchData()
    }, [id])

    const [selectedPage, setSelectedPage] = useState('電子書 1')

    const handleUpdateData = (newData) => {
        setdata(newData)
    }

    const [showClassSelectionPopup, setShowClassSelectionPopup] = useState(false)
    useEffect(() => {
        if (selectedPage === '上課互動區 1' || selectedPage === '上課互動區 2') {
            setShowClassSelectionPopup(true)
        } else {
            setShowClassSelectionPopup(false)
        }
    }, [selectedPage])
    const [isSettingMenuVisible, setIsSettingMenuVisible] = useState(false);


    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-row flex' style={{ fontSize }}>

            {/*menu bar*/}
            <div className='w-[330px] bg-[#F5F5F5] overflow-auto h-[100%] flex flex-col' style={{ backgroundImage: `url(/secondary/bg3.png)`, backgroundSize: 'cover', backgroundPosition: 'end' }}>
                <div className='relative w-full flex flex-col p-[16px] font-bold overflow-auto' style={{ minHeight: 186, backgroundImage: `url(${data?.mission?.photo})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className='absolute bottom-0 left-0 right-0 h-[50%] z-[1]' style={{ background: 'linear-gradient(to top, rgba(255,255,255,1), rgba(0,0,0,0))' }} />
                    <div>
                        <button className='px-[18px] py-[4px] rounded-full flex flex-row items-center text-[white] gap-[8px] noto-san-hk font-[600]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }} onClick={() => setIsSettingMenuVisible(!isSettingMenuVisible)}>
                            <img src='/secondary/setting.png' alt='設定' />
                            設定
                        </button>
                    </div>
                    <div className='flex-1 flex flex-col items-start justify-end z-[2] font-[900]'>{data?.mission?.name}</div>
                </div>

                <div className='px-[16px] font-bold text-[#003A57] mt-[23px]'>互文閱讀一</div>
                <div className='px-[16px] font-bold text-[#003A57]'>「{data?.mission?.pages?.[0]?.category}」</div>
                <div className='flex flex-col p-[16px] gap-[8px]'>
                    <button className='flex flex-row items-center gap-[8px] w-full underline py-[8px] px-[16px] rounded-[8px]  text-[#4B555C]' onClick={() => setSelectedPage('電子書 1')} style={selectedPage === '電子書 1' ? { fontWeight: '900', background: 'linear-gradient(to bottom, #BEBEBE80, #fff)' } : { fontWeight: '700' }}>
                        <div className='h-[8px] w-[8px] font-bold bg-[#003A57] rounded-full' />
                        電子書
                    </button>
                    <button className='flex flex-row items-center gap-[8px] w-full underline py-[8px] px-[16px] rounded-[8px]  text-[#4B555C]' onClick={() => setSelectedPage('工作紙生成 1')} style={selectedPage === '工作紙生成 1' ? { fontWeight: '900', background: 'linear-gradient(to bottom, #BEBEBE80, #fff)' } : { fontWeight: '700' }}>
                        <div className='h-[8px] w-[8px] font-bold bg-[#003A57] rounded-full' />
                        工作紙生成
                    </button>
                    <button className='flex flex-row items-center gap-[8px] w-full underline py-[8px] px-[16px] rounded-[8px]  text-[#4B555C]' onClick={() => setSelectedPage('上課互動區 1')} style={selectedPage === '上課互動區 1' ? { fontWeight: '900', background: 'linear-gradient(to bottom, #BEBEBE80, #fff)' } : { fontWeight: '700' }}>
                        <div className='h-[8px] w-[8px] font-bold bg-[#003A57] rounded-full' />
                        上課互動區
                    </button>
                </div>
                <div className='px-[16px] font-bold text-[#003A57] mt-[32px]'>互文閱讀二</div>
                <div className='px-[16px] font-bold text-[#003A57]'>「{data?.mission?.pages?.[1]?.category}」</div>
                <div className='flex flex-col p-[16px] gap-[8px]'>
                    <button className='flex flex-row items-center gap-[8px] w-full underline py-[8px] px-[16px] rounded-[8px]  text-[#4B555C]' onClick={() => setSelectedPage('電子書 2')} style={selectedPage === '電子書 2' ? { fontWeight: '900', background: 'linear-gradient(to bottom, #BEBEBE80, #fff)' } : { fontWeight: '700' }}>
                        <div className='h-[8px] w-[8px] font-bold bg-[#003A57] rounded-full' />
                        電子書
                    </button>
                    <button className='flex flex-row items-center gap-[8px] w-full underline py-[8px] px-[16px] rounded-[8px]  text-[#4B555C]' onClick={() => setSelectedPage('工作紙生成 2')} style={selectedPage === '工作紙生成 2' ? { fontWeight: '900', background: 'linear-gradient(to bottom, #BEBEBE80, #fff)' } : { fontWeight: '700' }}>
                        <div className='h-[8px] w-[8px] font-bold bg-[#003A57] rounded-full' />
                        工作紙生成
                    </button>
                    <button className='flex flex-row items-center gap-[8px] w-full underline py-[8px] px-[16px] rounded-[8px]  text-[#4B555C]' onClick={() => setSelectedPage('上課互動區 2')} style={selectedPage === '上課互動區 2' ? { fontWeight: '900', background: 'linear-gradient(to bottom, #BEBEBE80, #fff)' } : { fontWeight: '700' }}>
                        <div className='h-[8px] w-[8px] font-bold bg-[#003A57] rounded-full' />
                        上課互動區
                    </button>
                    <button className='flex flex-row items-center gap-[8px] w-full underline py-[8px] px-[16px] rounded-[8px]' onClick={() => setSelectedPage('單元習題')} style={selectedPage === '單元習題' ? { fontWeight: '900', background: 'linear-gradient(to bottom, #BEBEBE80, #fff)', } : { fontWeight: '700' }}>
                        單元習題
                    </button>
                    <button className='flex flex-row items-center gap-[8px] w-full underline py-[8px] px-[16px] rounded-[8px]' onClick={() => setSelectedPage('能力點表現')} style={selectedPage === '能力點表現' ? { fontWeight: '900', background: 'linear-gradient(to bottom, #BEBEBE80, #fff)' } : { fontWeight: '700' }}>
                        能力點表現
                    </button>
                </div>

                <div className='flex-1 flex-col flex justify-end p-[16px] items-center'>
                    <button onClick={() => { navigate('/platform2/missions') }} className='w-[90%] cursor-pointer flex flex-row justify-center items-center rounded-[16px] p-[16px] gap-[20px] mt-[16px]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }}>
                        <img src='/secondary/menu/logout.png' alt='' style={{ height: '36px', objectFit: 'contain' }} />
                        <div className='font-[900] text-center' style={{ color: 'white' }}>回返教學藍圖</div>
                    </button>
                </div>

            </div>

            <div className='flex flex-col flex-1 h-full noto-san-hk font-[400]'>
                {data && <SliderPage leftComponent={
                    selectedPage === '電子書 1' ?
                        <ElectronicBookSelection index={0} data={data} setdata={handleUpdateData} />
                        : selectedPage === '電子書 2' ?
                            <ElectronicBookSelection index={1} data={data} setdata={handleUpdateData} />
                            : selectedPage === '工作紙生成 1' ?
                                <WorkSheetEditor index={0} data={data} setdata={handleUpdateData} />
                                : selectedPage === '工作紙生成 2' ?
                                    <WorkSheetEditor index={1} data={data} setdata={handleUpdateData} />
                                    : selectedPage === '上課互動區 1' ?
                                        <InteractiveArea index={0} data={data} setdata={handleUpdateData} />
                                        : selectedPage === '上課互動區 2' ?
                                            <InteractiveArea index={1} data={data} setdata={handleUpdateData} />
                                            : selectedPage === '單元習題' ?
                                                <PracticeEditor data={data} setdata={handleUpdateData} />
                                                : selectedPage === '能力點表現' ?
                                                    <AbilityPointsLeft data={data} setdata={handleUpdateData} />
                                                    : null
                }
                    rightComponent={
                        selectedPage === '電子書 1' ?
                            <ElectronicBook selectedPage={selectedPage} index={0} data={data} setdata={handleUpdateData} />
                            : selectedPage === '電子書 2' ?
                                <ElectronicBook selectedPage={selectedPage} index={1} data={data} setdata={handleUpdateData} />
                                : selectedPage === '工作紙生成 1' ?
                                    <WorkSheet index={0} data={data} setdata={handleUpdateData} />
                                    : selectedPage === '工作紙生成 2' ?
                                        <WorkSheet index={1} data={data} setdata={handleUpdateData} />
                                        : selectedPage === '上課互動區 1' ?
                                            <ElectronicBook selectedPage={selectedPage} index={0} data={data} setdata={handleUpdateData} onSettingClick={() => { setShowClassSelectionPopup(true) }} />
                                            : selectedPage === '上課互動區 2' ?
                                                <ElectronicBook selectedPage={selectedPage} index={1} data={data} setdata={handleUpdateData} onSettingClick={() => { setShowClassSelectionPopup(true) }} />
                                                : selectedPage === '單元習題' ?
                                                    <PracticeZone selectedPage={selectedPage} data={data} setdata={handleUpdateData} />
                                                    : selectedPage === '能力點表現' ?
                                                        <AbilityPointsRight data={data} setdata={handleUpdateData} />
                                                        : null
                    } />}
            </div>

            {showClassSelectionPopup && <ClassSelectionPopup {...{ showClassSelectionPopup, setShowClassSelectionPopup }} />}

            {isLoading && <LoadingPage />}
            {isSettingMenuVisible && (
                <SettingPopup onClose={() => {navigate('/platform2/missions')}} onReturn={() => setIsSettingMenuVisible(false)} enableReturn={true} />
            )}
        </div>
    );
}

function WorkSheet(props) {
    const { fontSize } = useSetting();
    const getIndex = (index) => {
        //only start count when the question is selected
        let count = 0;
        for (let i = 0; i <= index; i++) {
            if (props.data?.pages?.[props.index]?.questions?.[i]?.selected) {
                count++;
            }
        }
        return count;
    }
    return (
        <div className='flex flex-col w-full h-full font-[700] gap-[16px] overflow-auto' style={{ fontSize }}>
            <div className='flex flex-row items-center justify-start p-[8px]' style={{ background: 'linear-gradient(to right, #63BBD1, #34778C)' }}>
                <button className='rounded-[8px] text-white px-[16px] py-[8px] bg-[#EE8D59]'>工作紙預覽</button>
            </div>
            <div className='flex flex-col w-full gap-[16px] px-[16px] overflow-auto'>
                <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'linear-gradient(to right, #003A57, #108B96)' }}>
                    <div className='text-white p-[16px]' style={{ fontSize: fontSize + 2 }}>核心問題</div>
                    <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]'>
                        <div>{props.data?.mission?.pages?.[props.index]?.core_questions?.[0]?.question}</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
                        <div className='flex flex-row justify-end'>
                            <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }}>
                                儲存
                            </button>
                        </div>
                    </div>
                </div>
                {props.data?.pages?.[props.index]?.questions?.map((question, index) => (
                    question.selected ?
                        <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                            <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {getIndex(index)}</div>
                            <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]'>
                                <div>{question?.question}</div>
                                {question.type === '選擇題' ?
                                    <div className='p-[8px] rounded-[8px] flex flex-col'>
                                        {question.options?.map((option, idx) => (
                                            <div key={idx}>
                                                <button className='text-black bg-[#ccc] px-[18px] py-[4px] rounded-[4px] mb-[4px] min-w-[200px]'>
                                                    {option.option}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    :
                                    <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
                                }
                                <div className='flex flex-row justify-end'>
                                    <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }}>
                                        儲存
                                    </button>
                                </div>
                            </div>
                        </div>
                        : null
                ))}
            </div>
        </div>
    );
}

function WorkSheetEditor(props) {
    const { fontSize } = useSetting();
    return (
        <div className='flex flex-col w-full h-full p-[16px] font-[700] gap-[16px] overflow-auto' style={{ fontSize }}>
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[white] p-[8px]'>
                <div style={{ fontSize: fontSize + 2 }}>核心問題</div>
                <div className='text-black w-full'>{props.data?.mission?.pages?.[props.index]?.core_questions?.[0]?.question}</div>
            </div>

            <div className='font-[900] text-[#34778C] flex flex-col w-full rounded-[8px] items-start' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1 , #63BBD1)' }}>
                <div className='flex flex-row justify-start w-full'>
                    <div className='text-white py-[8px] px-[24px]' style={{}}>互文閱讀管理</div>
                    <div className='flex-1 bg-[white]' style={{ borderTopLeftRadius: '99px' }}></div>
                </div>
                <div className='flex flex-col w-full gap-[4px] p-[8px]' style={{ borderTopLeftRadius: '16px', background: 'linear-gradient(to bottom, #fff, #F0FBFF)', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px' }}>
                    <div style={{ color: '#003A57', fontSize: fontSize + 2 }}>工作紙生成設定</div>
                    <div className='flex flex-col w-full bg-[#F1F1F1] p-[16px] rounded-[8px]'>
                        <div>能力點建議選擇</div>
                        <div className='w-full flex flex-row flex-wrap gap-[24px] mt-[16px]'>
                            {props.data?.mission?.pages?.[props.index]?.ability_points?.map((skill, idx) => (
                                <div className='flex flex-row items-center text-black gap-[8px]' key={idx}>
                                    <input type="checkbox" id={`ability_point_${idx}`} name={`ability_point_${idx}`} className='w-[20px] h-[20px]' value={skill} />
                                    <label>{skill}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div style={{ color: '#003A57', fontSize: fontSize + 2 }}>工作紙探究</div>
                    <VerticalDragableList lists={props.data?.pages?.[props.index]?.questions || []}
                        onUpdate={(newQuestions) => {
                            let data = { ...props.data };
                            data.pages[props.index].questions = newQuestions;
                            if (props.setdata) {
                                props.setdata(data);
                            }
                        }}
                    />
                    <div className='flex flex-row justify-center mt-[16px]'>
                        <button className='text-white px-[56px] py-[24px] rounded-[8px] font-bold' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} onClick={
                            () => {
                                let data = { ...props.data };
                                data.pages[props.index].questions = [...data.pages[props.index].questions, { selected: false, question: '...', type: '短答題', isEditing: true }];
                                if (props.setdata) {
                                    props.setdata(data);
                                }
                            }
                        }>
                            + 加入新探究
                        </button>
                    </div>
                </div>

            </div>

        </div>
    )
}

function InteractiveArea(props) {
    const { fontSize } = useSetting();
    const getIndex = (index) => {
        //only start count when the question is selected
        let count = 0;
        for (let i = 0; i <= index; i++) {
            if (props.data?.pages?.[props.index]?.questions?.[i]?.selected) {
                count++;
            }
        }
        return count;
    }
    return (
        <div className='flex flex-col w-full h-full font-[700] gap-[16px] overflow-auto' style={{ fontSize }}>
            <div className='flex flex-row items-center justify-start p-[8px]' style={{ background: 'linear-gradient(to right, #63BBD1, #34778C)' }}>
                <button className='rounded-[8px] text-white px-[16px] py-[8px] bg-[#EE8D59]'>工作紙預覽</button>
            </div>
            <div className='flex flex-col w-full gap-[16px] px-[16px] overflow-auto'>
                <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'linear-gradient(to right, #003A57, #108B96)' }}>
                    <div className='text-white p-[16px]' style={{ fontSize: fontSize + 2 }}>核心問題</div>
                    <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]'>
                        <div>{props.data?.mission?.pages?.[props.index]?.core_questions?.[0]?.question}</div>
                        <div className='text-[#9F0000]' style={{}}>學生答案結果</div>
                        <div className='flex flex-row justify-center'>
                            <button onClick={props.onSettingClick} className='w-[150px] text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white px-[4px] py-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                                <div className='rounded-full px-[16px] py-[4px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                                    更多學生答案
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                {props.data?.pages?.[props.index]?.questions?.map((question, index) => (
                    question.selected ?
                        <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                            <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {getIndex(index)}</div>
                            <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]'>
                                <div>{question?.question}</div>
                                {question.type === '選擇題' &&
                                    <div className='p-[8px] rounded-[8px] flex flex-col'>
                                        {question.options?.map((option, idx) => (
                                            <div key={idx}>
                                                <button className='text-black bg-[#ccc] px-[18px] py-[4px] rounded-[4px] mb-[4px] min-w-[200px]'>
                                                    {option.option}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                }
                                <div className='text-[#9F0000]' style={{}}>學生答案結果</div>
                                <div className='flex flex-row justify-center'>
                                    <button onClick={props.onSettingClick} className='w-[150px] text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white px-[4px] py-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                                        <div className='rounded-full px-[16px] py-[4px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                                            更多學生答案
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        : null
                ))}
            </div>
        </div>
    );
}


function PracticeZone(props) {
    const { fontSize } = useSetting();
    const [articleIndex, setArticleIndex] = useState(0);
    const NUMBER = 1000
    const [isViewingBook, setisViewingBook] = useState(true);
    const getIndex = (index) => {
        //only start count when the question is selected
        let count = 0;
        for (let i = 0; i <= index; i++) {
            if (props.data?.questions?.[i]?.selected) {
                count++;
            }
        }
        return count;
    }
    return (
        <div className='flex flex-col w-full h-full font-[700] gap-[16px] overflow-auto' style={{ fontSize }}>
            <div className='flex flex-row items-center justify-start p-[8px] h-[50px] gap-[16px]' style={{ background: 'linear-gradient(to right, #63BBD1, #34778C)' }}>
                <button onClick={() => { setisViewingBook(true) }}>
                    <img src={`/secondary/book${isViewingBook ? '' : '_'}.png`} style={{ height: '40px', objectFit: 'contain' }} />
                </button>
                <button onClick={() => { setisViewingBook(false) }}>
                    <img src={`/secondary/practice${isViewingBook ? '_' : ''}.png`} style={{ height: '40px', objectFit: 'contain' }} />
                </button>
            </div>
            {isViewingBook && <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px]'>
                {props.data?.mission?.pages?.[0]?.articles?.map((article, index) => (
                    props.data?.pages2?.[0]?.articles?.[index]?.selected || props.data?.pages2?.[0]?.articles?.[index]?.sections?.some(section => section?.selected) ?
                        <button
                            className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                            style={articleIndex === index ? { background: 'linear-gradient(to right, #63BBD1, #34778C)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                            onClick={() => setArticleIndex(index)}
                        >
                            篇章{index === 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' : index + 1}
                        </button>
                        : null
                ))}
                {props.data?.mission?.pages?.[1]?.articles?.map((article, index) => (
                    props.data?.pages2?.[1]?.articles?.[index]?.selected || props.data?.pages2?.[1]?.articles?.[index]?.sections?.some(section => section?.selected) ?
                        <button
                            className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                            style={articleIndex === index + NUMBER ? { background: 'linear-gradient(to right, #63BBD1, #34778C)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                            onClick={() => setArticleIndex(index + NUMBER)}
                        >
                            篇章{index === 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' : index + 1}
                        </button>
                        : null
                ))}
            </div>}
            {isViewingBook && <div className='flex flex-col w-full px-[16px] gap-[16px]'>
                {props.data?.mission?.pages?.[0]?.articles?.[articleIndex]?.sections?.map((section, sectionIndex) =>
                    (props.data?.pages2?.[0]?.articles?.[articleIndex]?.selected && section.type === 'main') || props.data?.pages2?.[0]?.articles?.[articleIndex]?.sections?.[sectionIndex]?.selected ?
                        <RenderASection section={section} key={sectionIndex} /> : null
                )}
                {articleIndex >= NUMBER && props.data?.mission?.pages?.[1]?.articles?.[articleIndex - NUMBER]?.sections?.map((section, sectionIndex) =>
                    (props.data?.pages2?.[1]?.articles?.[articleIndex - NUMBER]?.selected && section.type === 'main') || props.data?.pages2?.[1]?.articles?.[articleIndex - NUMBER]?.sections?.[sectionIndex]?.selected ?
                        <RenderASection section={section} key={sectionIndex} /> : null
                )}
            </div>}

            {!isViewingBook && <div className='flex flex-col w-full gap-[16px] px-[16px] overflow-auto'>
                {props.data?.questions?.map((question, index) => (
                    question.selected ?
                        <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                            <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {getIndex(index)}</div>
                            <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]'>
                                <div>{question?.question}</div>
                                {question.type === '選擇題' ?
                                    <div className='p-[8px] rounded-[8px] flex flex-col'>
                                        {question.options?.map((option, idx) => (
                                            <div key={idx}>
                                                <button className='text-black bg-[#ccc] px-[18px] py-[4px] rounded-[4px] mb-[4px] min-w-[200px]'>
                                                    {option.option}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    :
                                    <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
                                }
                                <div className='flex flex-row justify-end'>
                                    <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }}>
                                        儲存
                                    </button>
                                </div>
                            </div>
                        </div>
                        : null
                ))}

            </div>}
        </div>
    );
}

function ElectronicBook(props) {
    const { fontSize } = useSetting();
    const [articleIndex, setArticleIndex] = useState(0);
    return (
        <div className='flex flex-col w-full h-full font-[700] gap-[16px] overflow-auto' style={{ fontSize }}>
            <div className='flex flex-row items-center justify-between p-[8px]' style={{ background: 'linear-gradient(to right, #63BBD1, #34778C)' }}>
                {props.selectedPage.includes('電子書') ?
                    <button className='rounded-[8px] text-white px-[16px] py-[8px] bg-[#EE8D59]'>電子書預覽</button>
                    : <div className='text-white font-[900]'>電子書</div>
                }
                {props.selectedPage.includes('電子書') ? null :
                    <button onClick={props.onSettingClick} className='w-[150px] text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                        <div className='rounded-full px-[16px] py-[4px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                            {'顯示設定'}
                        </div>
                    </button>
                }
            </div>
            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px]'>
                {props.data?.mission?.pages?.[props.index]?.articles?.map((article, index) => (
                    props.data?.pages?.[props.index]?.articles?.[index]?.selected || props.data?.pages?.[props.index]?.articles?.[index]?.sections?.some(section => section?.selected) ?
                        <button
                            className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                            style={articleIndex === index ? { background: 'linear-gradient(to right, #63BBD1, #34778C)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                            onClick={() => setArticleIndex(index)}
                        >
                            篇章{index === 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' : index + 1}
                        </button>
                        : null
                ))}
            </div>
            <div className='flex flex-col w-full px-[16px] gap-[16px]'>
                {props.data?.mission?.pages?.[props.index]?.articles?.[articleIndex]?.sections?.map((section, sectionIndex) =>
                    (props.data?.pages?.[props.index]?.articles?.[articleIndex]?.selected && section.type === 'main') || props.data?.pages?.[props.index]?.articles?.[articleIndex]?.sections?.[sectionIndex]?.selected ?
                        <RenderASection section={section} key={sectionIndex} /> : null
                )}
            </div>
        </div>
    );
}

function ElectronicBookSelection(props) {
    const { fontSize } = useSetting();
    useEffect(() => {
        //auto select the first article
        if (props.data?.mission?.pages?.[props.index]?.articles?.length > 0) {
            const firstArticle = props.data.mission.pages[props.index].articles[0];
            if (firstArticle) {
                firstArticle.selected = true;
            }
        }
        if (props.setdata) {
            const newData = { ...props.data };
            newData.pages = [...newData.pages || []];
            newData.pages[props.index] = { ...newData.pages?.[props.index] || {}, }
            newData.pages[props.index].articles = [...newData.pages[props.index]?.articles || []];
            newData.pages[props.index].articles[0] = {
                ...newData.pages[props.index].articles[0] || {},
                selected: true
            };
            props.setdata(newData);
        }
    }, [props.index]);
    return (
        <div className='flex flex-col w-full h-full p-[16px] font-[700] gap-[16px] overflow-auto' style={{ fontSize }}>
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[white] p-[8px]'>
                <div style={{ fontSize: fontSize + 2 }}>核心問題</div>
                <div className='text-black w-full'>{props.data?.mission?.pages?.[props.index]?.core_questions?.[0]?.question}</div>
            </div>

            <div className='font-[900] text-[#34778C] flex flex-col w-full rounded-[8px] items-start' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1 , #63BBD1)' }}>
                <div className='flex flex-row justify-start w-full'>
                    <div className='text-white py-[8px] px-[24px]' style={{}}>互文閱讀管理</div>
                    <div className='flex-1 bg-[white]' style={{ borderTopLeftRadius: '99px' }}></div>
                </div>
                <div className='flex flex-col w-full gap-[4px] p-[8px]' style={{ borderTopLeftRadius: '16px', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', background: 'linear-gradient(to bottom, #fff, #F0FBFF)' }}>
                    <div style={{ color: '#003A57', fontSize: fontSize + 2 }}>單元習題 - 電子書設定</div>
                    <div className='text-[#4B555C] font-[400] w-full' style={{ fontSize: fontSize - 2 }}>互文閱讀{props.index === 0 ? '一' : '二'}「{props.data?.mission?.pages?.[props.index]?.category || ''}」</div>
                    {
                        props.data?.mission?.pages?.[props.index]?.articles?.map((article, articleIndex) => (
                            <div key={articleIndex} className='flex flex-col w-full gap-[4px] p-[8px]'>
                                <div className='flex flex-row items-center gap-[8px] checkbox-main'>
                                    <input type='checkbox' checked={props.data?.pages?.[props.index]?.articles?.[articleIndex]?.selected || false} onChange={() => {
                                        if (props.setdata) {
                                            const newData = { ...props.data };
                                            newData.pages = [...newData.pages || []]
                                            newData.pages[props.index] = { ...newData.pages?.[props.index] || {}, }
                                            newData.pages[props.index].articles = [...newData.pages[props.index]?.articles || []];
                                            newData.pages[props.index].articles[articleIndex] = {
                                                ...newData.pages[props.index].articles[articleIndex] || {},
                                                selected: !newData.pages[props.index].articles[articleIndex]?.selected
                                            };
                                            props.setdata(newData);
                                        }
                                    }} />
                                    <div className='text-black w-full'>篇章{articleIndex === 0 ? '一' : articleIndex === 1 ? '二' : articleIndex === 2 ? '三' : articleIndex === 3 ? '四' : articleIndex === 4 ? '五' : articleIndex + 1}</div>
                                </div>
                                {article?.sections?.map((section, sectionIndex) => (
                                    section.type === 'main' ?
                                        <div key={sectionIndex} className='checkbox-main text-black w-full text-left flex flex-row items-center gap-[8px] font-[600] px-[8px] py-[4px] rounded-[8px]' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to right, #D5D8DB, #ffffff)' }}>
                                            <input type='checkbox'
                                                checked={props.data?.pages?.[props.index]?.articles?.[articleIndex]?.selected || props.data?.pages?.[props.index]?.articles?.[articleIndex]?.sections?.[sectionIndex]?.selected || false}
                                                disabled={props.data?.pages?.[props.index]?.articles?.[articleIndex]?.selected}
                                                style={{ opacity: props.data?.pages?.[props.index]?.articles?.[articleIndex]?.selected ? 0.5 : 1 }}
                                                onClick={() => {
                                                    const newData = { ...props.data };
                                                    newData.pages = [...newData.pages || []]
                                                    newData.pages[props.index] = { ...newData.pages?.[props.index] || {}, }
                                                    newData.pages[props.index].articles = [...newData.pages[props.index]?.articles || []];
                                                    newData.pages[props.index].articles[articleIndex] = {
                                                        ...newData.pages[props.index]?.articles?.[articleIndex] || {},
                                                        sections: [...newData.pages[props.index]?.articles[articleIndex]?.sections || []]
                                                    };
                                                    newData.pages[props.index].articles[articleIndex].sections[sectionIndex] = {
                                                        ...newData.pages[props.index]?.articles[articleIndex]?.sections[sectionIndex] || {},
                                                        selected: !newData.pages[props.index]?.articles[articleIndex]?.sections[sectionIndex]?.selected
                                                    };
                                                    props.setdata(newData);
                                                }}
                                            />
                                            <div>{section.name || ''}</div>
                                        </div> : null
                                ))}
                                {article?.sections?.map((section, sectionIndex) => (
                                    section.type === 'sub' ?
                                        <div key={sectionIndex} className='checkbox-sub text-black w-full text-left flex flex-row items-center gap-[8px] font-[600] px-[8px] py-[4px] rounded-[8px]' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to right, #D5D8DB, #ffffff)' }}>
                                            <input type='checkbox' className='ml-[24px]'
                                                checked={props.data?.pages?.[props.index]?.articles?.[articleIndex]?.sections?.[sectionIndex]?.selected || false}
                                                disabled={false}
                                                style={{ opacity: 1 }}
                                                onClick={() => {
                                                    const newData = { ...props.data };
                                                    newData.pages = [...newData.pages || []]
                                                    newData.pages[props.index] = { ...newData.pages?.[props.index] || {}, }
                                                    newData.pages[props.index].articles = [...newData.pages[props.index]?.articles || []];
                                                    newData.pages[props.index].articles[articleIndex] = {
                                                        ...newData.pages[props.index]?.articles?.[articleIndex] || {},
                                                        sections: [...newData.pages[props.index]?.articles[articleIndex]?.sections || []]
                                                    };
                                                    newData.pages[props.index].articles[articleIndex].sections[sectionIndex] = {
                                                        ...newData.pages[props.index]?.articles[articleIndex]?.sections[sectionIndex] || {},
                                                        selected: !newData.pages[props.index]?.articles[articleIndex]?.sections[sectionIndex]?.selected
                                                    };
                                                    props.setdata(newData);
                                                }}
                                            />
                                            <div>{section.name || ''}</div>
                                        </div> : null
                                ))}
                            </div>
                        ))
                    }
                </div>

            </div>

        </div>
    );
}



function PracticeEditor(props) {
    const { fontSize } = useSetting();
    useEffect(() => {
        //auto select the first article
        if (props.data?.mission?.pages?.[0]?.articles?.length > 0) {
            const firstArticle = props.data?.pages2?.[0]?.articles?.[0]
            if (firstArticle) {
                firstArticle.selected = true;
            }
        }
        if (props.setdata) {
            const newData = { ...props.data };
            newData.pages2 = [...newData.pages2 || []];
            newData.pages2[0] = { ...newData.pages2?.[props.index] || {}, }
            newData.pages2[0].articles = [...newData.pages2[props.index]?.articles || []];
            newData.pages2[0].articles[0] = {
                ...newData.pages2[0].articles[0] || {},
                selected: true
            };
            props.setdata(newData);
        }
    }, []);
    return (
        <div className='flex flex-col w-full h-full p-[16px] font-[700] gap-[16px] overflow-auto' style={{ fontSize }}>

            <div className='font-[900] text-[#34778C] flex flex-col w-full rounded-[8px] items-start' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1 , #63BBD1)' }}>
                <div className='flex flex-row justify-start w-full'>
                    <div className='text-white py-[8px] px-[24px]' style={{}}>互文閱讀管理</div>
                    <div className='flex-1 bg-[white]' style={{ borderTopLeftRadius: '99px' }}></div>
                </div>
                <div className='flex flex-col w-full gap-[4px] p-[8px]' style={{ borderTopLeftRadius: '16px', background: 'linear-gradient(to bottom, #fff, #F0FBFF)', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px' }}>
                    <div style={{ color: '#003A57', fontSize: fontSize + 2 }}>單元習題 - 電子書設定</div>

                    {[0, 1].map(index =>
                        <div key={index} className='w-full flex flex-col'>
                            <div className='text-[#4B555C] font-[400] w-full' style={{ fontSize: fontSize - 2 }}>互文閱讀{index === 0 ? '一' : '二'}「{props.data?.mission?.pages?.[index]?.category || ''}」</div>
                            {
                                props.data?.mission?.pages?.[index]?.articles?.map((article, articleIndex) => (
                                    <div key={articleIndex} className='flex flex-col w-full gap-[4px] p-[8px]'>
                                        <div className='flex flex-row items-center gap-[8px] checkbox-main'>
                                            <input type='checkbox' checked={props.data?.pages2?.[index]?.articles?.[articleIndex]?.selected || false} onChange={() => {
                                                if (props.setdata) {
                                                    const newData = { ...props.data };
                                                    newData.pages2 = [...newData.pages2 || []]
                                                    newData.pages2[index] = { ...newData.pages2?.[index] || {}, }
                                                    newData.pages2[index].articles = [...newData.pages2[index]?.articles || []];
                                                    newData.pages2[index].articles[articleIndex] = {
                                                        ...newData.pages2[index].articles[articleIndex] || {},
                                                        selected: !newData.pages2[index].articles[articleIndex]?.selected
                                                    };
                                                    props.setdata(newData);
                                                }
                                            }} />
                                            <div className='text-black w-full'>篇章{articleIndex === 0 ? '一' : articleIndex === 1 ? '二' : articleIndex === 2 ? '三' : articleIndex === 3 ? '四' : articleIndex === 4 ? '五' : articleIndex + 1}</div>
                                        </div>
                                        {article?.sections?.map((section, sectionIndex) => (
                                            section.type === 'main' ?
                                                <div key={sectionIndex} className='text-black w-full text-left flex flex-row items-center gap-[8px] font-[600] px-[8px] py-[4px] rounded-[8px] checkbox-main' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to right, #D5D8DB, #ffffff)' }}>
                                                    <input type='checkbox'
                                                        checked={props.data?.pages2?.[index]?.articles?.[articleIndex]?.selected || props.data?.pages2?.[index]?.articles?.[articleIndex]?.sections?.[sectionIndex]?.selected || false}
                                                        disabled={props.data?.pages2?.[index]?.articles?.[articleIndex]?.selected}
                                                        style={{ opacity: props.data?.pages2?.[index]?.articles?.[articleIndex]?.selected ? 0.5 : 1 }}
                                                        onClick={() => {
                                                            const newData = { ...props.data };
                                                            newData.pages2 = [...newData.pages2 || []]
                                                            newData.pages2[index] = { ...newData.pages2?.[index] || {}, }
                                                            newData.pages2[index].articles = [...newData.pages2[index]?.articles || []];
                                                            newData.pages2[index].articles[articleIndex] = {
                                                                ...newData.pages2[index]?.articles?.[articleIndex] || {},
                                                                sections: [...newData.pages2[index]?.articles[articleIndex]?.sections || []]
                                                            };
                                                            newData.pages2[index].articles[articleIndex].sections[sectionIndex] = {
                                                                ...newData.pages2[index]?.articles[articleIndex]?.sections[sectionIndex] || {},
                                                                selected: !newData.pages2[index]?.articles[articleIndex]?.sections[sectionIndex]?.selected
                                                            };
                                                            props.setdata(newData);
                                                        }}
                                                    />
                                                    <div>{section.name || ''}</div>
                                                </div> : null
                                        ))}
                                        {article?.sections?.map((section, sectionIndex) => (
                                            section.type === 'sub' ?
                                                <div key={sectionIndex} className='text-black w-full text-left flex flex-row items-center gap-[8px] font-[600] px-[8px] py-[4px] rounded-[8px] checkbox-sub' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to right, #D5D8DB, #ffffff)' }}>
                                                    <input type='checkbox' className='ml-[24px]'
                                                        checked={props.data?.pages2?.[index]?.articles?.[articleIndex]?.sections?.[sectionIndex]?.selected || false}
                                                        disabled={false}
                                                        style={{ opacity: 1 }}
                                                        onClick={() => {
                                                            const newData = { ...props.data };
                                                            newData.pages2 = [...newData.pages2 || []]
                                                            newData.pages2[index] = { ...newData.pages2?.[index] || {}, }
                                                            newData.pages2[index].articles = [...newData.pages2[index]?.articles || []];
                                                            newData.pages2[index].articles[articleIndex] = {
                                                                ...newData.pages2[index]?.articles?.[articleIndex] || {},
                                                                sections: [...newData.pages2[index]?.articles[articleIndex]?.sections || []]
                                                            };
                                                            newData.pages2[index].articles[articleIndex].sections[sectionIndex] = {
                                                                ...newData.pages2[index]?.articles[articleIndex]?.sections[sectionIndex] || {},
                                                                selected: !newData.pages2[index]?.articles[articleIndex]?.sections[sectionIndex]?.selected
                                                            };
                                                            props.setdata(newData);
                                                        }}
                                                    />
                                                    <div>{section.name || ''}</div>
                                                </div> : null
                                        ))}
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>

            </div>


            <div className='font-[900] text-[#34778C] flex flex-col w-full rounded-[8px] items-start' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1 , #63BBD1)' }}>
                <div className='flex flex-row justify-start w-full'>
                    <div className='text-white py-[8px] px-[24px]' style={{}}>互文閱讀管理</div>
                    <div className='flex-1 bg-[white]' style={{ borderTopLeftRadius: '99px' }}></div>
                </div>
                <div className='flex flex-col w-full gap-[4px] p-[8px]' style={{ borderTopLeftRadius: '16px', background: 'linear-gradient(to bottom, #fff, #F0FBFF)', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px' }}>
                    <div style={{ color: '#003A57', fontSize: fontSize + 2 }}>工作紙生成設定</div>
                    <div className='flex flex-col w-full bg-[#F1F1F1] p-[16px] rounded-[8px]'>
                        <div>能力點建議選擇</div>
                        <div className='w-full flex flex-row flex-wrap gap-[24px] mt-[16px]'>
                            {[...props.data?.mission?.pages?.[0]?.ability_points || [], ...props.data?.mission?.pages?.[1]?.ability_points || []]?.map((skill, idx) => (
                                <div className='flex flex-row items-center text-black gap-[8px]' key={idx}>
                                    <input type="checkbox" id={`ability_point_${idx}`} name={`ability_point_${idx}`} className='w-[20px] h-[20px]' value={skill} />
                                    <label>{skill}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div style={{ color: '#003A57', fontSize: fontSize + 2 }}>工作紙探究</div>
                    <VerticalDragableList lists={props.data?.questions || []}
                        onUpdate={(newQuestions) => {
                            let data = { ...props.data };
                            data.questions = newQuestions;
                            if (props.setdata) {
                                props.setdata(data);
                            }
                        }}
                    />
                    <div className='flex flex-row justify-center mt-[16px]'>
                        <button className='text-white px-[56px] py-[2篇章4px] rounded-[8px] font-bold' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} onClick={
                            () => {
                                let data = { ...props.data };
                                data.questions = [...data?.questions, { selected: false, question: '...', type: '短答題', isEditing: true }];
                                if (props.setdata) {
                                    props.setdata(data);
                                }
                            }
                        }>
                            + 加入新探究
                        </button>
                    </div>
                </div>

            </div>


        </div>
    );
}


function RenderASection({ section }) {
    const { fontSize } = useSetting();
    return (
        <div className='flex flex-col items-center justify-start gap-[16px] w-full rounded-[8px] py-[16px]' style={section.backgroundImage ? { backgroundImage: `url(${section.backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundColor: section.backgroundColor || 'transparent' } : { backgroundColor: section.backgroundColor || 'transparent' }}>
            {section?.contents?.map((content, contentIndex) => (
                <div key={contentIndex} className='text-black w-full flex items-center justify-center'>
                    {content.type === '圖片' ?
                        <img className='px-[32px]' src={content.url} alt='' />
                        : content.type === '標題' ?
                            <div className='text-black font-bold text-center w-[90%] px-[32px]' style={{ fontSize: fontSize + 4 }}>{content.text}</div>
                            : content.type === '文字' ?
                                <div className='px-[32px] py-[8px] text-justify flex flex-col items-center justify-center font-[400]' dangerouslySetInnerHTML={{ __html: content.text }}></div>
                                : content.type
                    }
                </div>
            ))}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
